/** Public marketing / booking URLs (safe to import in client bundle). */

/**
 * Calendly URL for /demo when the SPA handles the route (local dev).
 * Set REACT_APP_DEMO_BOOKING_URL at build time — no hardcoded default in code.
 */
export function getDemoBookingUrl() {
  const url = (process.env.REACT_APP_DEMO_BOOKING_URL || '').trim();
  return url || null;
}

export const DEMO_BOOKING_URL = getDemoBookingUrl();

export default { getDemoBookingUrl, DEMO_BOOKING_URL };
